import CustomersCreateQuickFormFields from './CustomersCreateQuickFormFields';

export default CustomersCreateQuickFormFields;
